var _process$env$REACT_AP;
import Support from "../icons/Support";
import Github from "../icons/Github";
import Instagram from "../icons/Instagram";
import Telegram from "../icons/Telegram";
import Twitter from "../icons/Twitter";
import Email from "../icons/Email";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const navigation = [{
  name: "Support",
  href: "https://medium.com/@iranunchained",
  testid: "support",
  icon: Support
}, {
  name: "GitHub",
  href: "https://github.com/iranunchained/",
  testid: "github",
  icon: Github
}, {
  name: "Instagram",
  href: "https://instagram.com/iranunchained",
  testid: "instagram",
  icon: Instagram
}, {
  name: "Telegram",
  href: "https://telegram.me/iranunchained",
  testid: "telegram",
  icon: Telegram
}, {
  name: "Twitter",
  href: "https://twitter.com/UnchainIran",
  testid: "twitter",
  icon: Twitter
}, {
  name: "Email",
  href: "mailto:iranunchained@proton.me",
  testid: "email",
  icon: Email
}];
const COMMIT_HASH = (_process$env$REACT_AP = process.env.REACT_APP_GIT_SHA) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "localhost";
export default function Footer() {
  return /*#__PURE__*/_jsxs("footer", {
    className: "p-3 px-8 flex flex-row justify-between items-center",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "text-gray-500 text-xs",
      children: ["build ", /*#__PURE__*/_jsx("pre", {
        className: "inline",
        children: COMMIT_HASH
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-row-reverse justify-between py-12 overflow-hidden",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex justify-around space-x-4 md:order-1",
        children: navigation.map(item => /*#__PURE__*/_jsxs("a", {
          href: item.href,
          className: "text-gray-400 hover:text-gray-500",
          "data-testid": item.testid,
          children: [/*#__PURE__*/_jsx("span", {
            className: "sr-only hidden",
            children: item.name
          }), /*#__PURE__*/_jsx(item.icon, {})]
        }, item.name))
      })
    })]
  });
}